<div class="p-2 flex flex-col space-y-2">
  @if (!auth.loggedIn$()) {
    <app-auth-otp (otpToken)="handleOtpToken($event)"></app-auth-otp>
  }

  @if (auth.loggedIn$()) {
    <div class="flex w-full justify-end">
      <app-button (click)="auth.logout()">Logout</app-button>
    </div>
    <app-card [loading]="loadingAppts$()">
      <div header>{{ 'Profile' | localizeText : 'Profile' }}</div>
      <div body class="p-2">
        <div class="flex flex-col space-y-2" style="max-width: 400px;">
          <div class="flex flex-col">
            <label class="label-style">{{ 'FirstName' | localizeText : 'First Name' }}</label>
            <input type="text" [(ngModel)]="firstName$" class="input-default">
          </div>
          <div class="flex flex-col">
            <label class="label-style">{{ 'LastName' | localizeText : 'Last Name' }}</label>
            <input type="text" [(ngModel)]="lastName$" class="input-default">
          </div>
          <app-button [loading$]="loadingParticipantUpdate$()" (click)="updateParticipant()">{{ 'Save' | localizeText : 'Save' }}</app-button>
        </div>
      </div>
    </app-card>
    @if (!appointmentId$()) {
      <app-card [loading]="loadingAppts$()">
        <div header>{{ 'Appointments' | localizeText : 'Appointments' }}</div>
        <div body>
          <div class="flex flex-col space-y-2 p-2">
            @for (appt of appts$(); track appt) {
              <div class="flex justify-between bg-gray-850 hover:bg-opacity-80 transition cursor-pointer rounded p-2 items-center" (click)="appointmentId$.set(appt.appointment.id)">
                <div class="flex flex-col">
                  <span>{{ appt.appointment.title }}</span>
                  <span class="text-sm">{{ appt.appointment.startTime | localizedDate : 'longDate' }}</span>
                  <div class="flex space-x-1 label-style">
                    <span>{{ appt.appointment.startTime | localizedDate : 'HH:mm aa' }}</span>
                    <span>-</span>
                    <span>{{ appt.appointment.endTime | localizedDate : 'HH:mm aa' }}</span>
                  </div>
                </div>
                <app-icon icon="mdi-chevron-right"></app-icon>
              </div>
            }
          </div>
        </div>
      </app-card>
    }
    @if (appointmentId$()) {
      <app-appointment-call-modal
        (onHangup)="appointmentId$.set(null)"
      [appointmentId]="appointmentId$()"></app-appointment-call-modal>
    }
  }

</div>
